module.exports = __webpack_public_path__ + "static/media/CV.78bf276f.svg";